import React from 'react';
import '../css/CentroInnovacion.css';

import proyectos from '../data/centroInnovacion';

const CentroInnovacion = () => {

    const renderMedia = (proyecto) => {

        const extension = proyecto.archivo
            .split('.')
            .pop()
            .toLowerCase();

        // VIDEO
        if (['mp4', 'mov', 'webm'].includes(extension)) {

            return (

                <video
                    className="esc-ci-media"
                    src={proyecto.archivo}
                    autoPlay
                    muted
                    loop
                    playsInline
                    controls
                />

            );

        }

        // PDF

        if (extension === "pdf") {

            return (

                <iframe
                    title={proyecto.titulo}
                    src={proyecto.archivo}
                    className="esc-ci-media"
                />

            );

        }

        // IMAGEN

        return (

            <img
                src={proyecto.archivo}
                alt={proyecto.titulo}
                className="esc-ci-media"
            />

        );

    };

    return (

        <section
            id="centro-innovacion-component"
            className="esc-ci-section"
        >

            <div className="esc-ci-header">

                <h2 className="esc-ci-title">

                    Centro de Innovación

                </h2>

                <div className="esc-ci-divider">

                    <span className="esc-ci-red"></span>

                    <span className="esc-ci-blue"></span>

                </div>

                <p className="esc-ci-description">

                    En este espacio compartimos proyectos,
                    experiencias y actividades desarrolladas por
                    nuestros estudiantes en programación,
                    pensamiento computacional, creatividad digital
                    e innovación tecnológica.

                </p>

            </div>

            <div className="esc-ci-grid">

                {proyectos.map((proyecto) => (

                    <div
                        key={proyecto.id}
                        className="esc-ci-card"
                    >

                        {renderMedia(proyecto)}

                        <div className="esc-ci-content">

                            <span className="esc-ci-category">

                                {proyecto.categoria}

                            </span>

                            <h3>

                                {proyecto.titulo}

                            </h3>

                            <p>

                                {proyecto.descripcion}

                            </p>

                            {proyecto.link && (

                                <a
                                    href={proyecto.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="esc-ci-button"
                                >

                                    Ver Proyecto

                                </a>

                            )}

                        </div>

                    </div>

                ))}

            </div>

        </section>

    );

};

export default CentroInnovacion;